import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, CardContent } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import CommonButton from './CommonButton';
import CommonSearch from './CommonSearch';
import {
  getPrimaryFilters,
  getClients,
  getProductByClientId,
  getCampaignsByProductCode,
  getEstimatesByProductCode,
} from '../redux/actions/common';
import { showToast } from '../Utils';

const ClientPrimaryFilters = ({
  fetchCampaigns,
  fetchClients,
  fetchProducts,
  clients,
  Campaigns,
  fetchFunction,
  selectedValue,
  visibleProduct,
  visibleEstimate,
  location,
  showFetchButton,
  productFilter,
  fetchEstimates,
  estimates,
}) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const [campaigns, setCampaigns] = useState(null);
  const [estimatesVal, setEstimatesVal] = useState(null);
  const [client, setClient] = useState(null);
  const [product, setProduct] = useState(null);
  const [fetchButton, enableFetchButton] = useState(true);
  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  useEffect(() => {
    setCampaigns(null);
    setEstimatesVal(null);
    setClient(null);
    setProduct(null);
  }, [location]);

  const clientOptions = clients.map((obj) => ({
    text: obj.clientName,
    value: obj.clientId,
  }));

  const productOptions = productFilter.map((obj) => ({
    text: obj.productName,
    value: obj.productCode,
  }));

  const campaignsOptions = Campaigns.map((obj) => ({
    text: obj.campaignDescription,
    value: obj.campaignNo,
  }));
  const estimatesOptions = estimates.map((obj) => ({
    text: `${obj.estimateNo} ${obj.campaignDescription}`,
    value: obj.estimateNo,
    id: obj.estimateId,
  }));

  const handleChangeClients = (val) => {
    if (val) {
      setClient(val);
      fetchProducts(val.value);
      if (selectedValue) {
        selectedValue(val);
      }
    } else {
      setClient(null);
    }
    setProduct(null);
    setCampaigns(null);
    setEstimatesVal(null);

    enableFetchButton(true);
  };

  const handleChangeProducts = (val) => {
    if (val) {
      setProduct(val);
      if (user.userType === 'client') {
        fetchCampaigns(val.value);
      } else {
        fetchEstimates(val.value);
      }
    } else {
      setProduct(null);
    }
    setEstimatesVal(null);
    setCampaigns(null);

    enableFetchButton(true);
  };

  const handleChangeCampaigns = (val) => {
    if (val) {
      if (user.userType === 'client') {
        enableFetchButton(false);
        setCampaigns(val);
      } else {
        enableFetchButton(false);
        setEstimatesVal(val);
      }
    } else {
      setCampaigns(null);
      setEstimatesVal(null);
      enableFetchButton(true);
    }
  };

  const fetchData = () => {
    if (fetchFunction) {
      switch (location) {
        case 'clientReportedSites':
          if (campaigns && campaigns?.value) {
            fetchFunction(campaigns?.value);
          }
          break;
        case 'siteRapportAuditor':
          if (estimatesVal && estimatesVal?.id) {
            fetchFunction(estimatesVal?.id);
          }
          break;
        case 'atrReport':
          if (user.userType === 'client') {
            if (campaigns && campaigns?.value) {
              fetchFunction(campaigns?.value);
            }
          } else if (user.userType === 'auditor') {
            if (estimatesVal && estimatesVal?.id) {
              fetchFunction(estimatesVal?.id);
            }
          }
          break;
        default:
          break;
      }
    } else {
      showToast('warning', 'Can not perform any task');
    }
  };

  useEffect(() => {
    if (clients?.length) {
      handleChangeClients({
        text: clients[0].clientName,
        value: clients[0].clientId,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, location]);
  return (
    <Card>
      <br />
      <CardContent>
        <div className="row">
          <div className="col-6">
            <CommonSearch
              label="Clients"
              value={client}
              data={clientOptions}
              onChange={handleChangeClients}
            />
          </div>
          {visibleProduct ? (
            <div className="col-6">
              <CommonSearch
                label="Products"
                disabled={!client}
                value={product}
                data={productOptions}
                onChange={handleChangeProducts}
              />
            </div>
          ) : null}
        </div>
        <div className="row mt-2">
          {visibleEstimate ? (
            <div className="col-9">
              <CommonSearch
                label={
                  user.userType === 'client' ? 'Campaign Filter' : 'Estimates'
                }
                disabled={!product}
                value={user.userType === 'client' ? campaigns : estimatesVal}
                data={
                  user.userType === 'client'
                    ? campaignsOptions
                    : estimatesOptions
                }
                onChange={handleChangeCampaigns}
              />
            </div>
          ) : null}
          {showFetchButton ? (
            <div className="col-3">
              <CommonButton
                className="wide-200"
                variant="outlined"
                color="primary"
                disabled={fetchButton}
                startIcon={<FilterListIcon />}
                onClick={() => fetchData()}
              >
                Fetch Sites
              </CommonButton>
            </div>
          ) : (
            <div className="col-3">
              <CommonButton
                disabled={!product || !(user.userType === 'client' ? campaigns : estimatesVal) || !client}
                variant="contained"
                color="primary"
                size="small"
                onClick={() => fetchData()}
              >
                Generate Report
              </CommonButton>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

const mapState = (state) => ({
  clients: state.common.clientsDashboard,
  Campaigns: state.common.campaignsOfClientDashboard,
  estimates: state.common.estimatesOfClientDashboard,
  productFilter: state.common.productsOfClientDashboard,
});

const mapActions = {
  getPFilters: getPrimaryFilters,
  fetchCampaigns: getCampaignsByProductCode,
  fetchEstimates: getEstimatesByProductCode,
  fetchClients: getClients,
  fetchProducts: getProductByClientId,
};

export default connect(mapState, mapActions)(ClientPrimaryFilters);
